(() => {
  const cfg = window.EMESA_THEME || {};
  const routes = cfg.routes || {};
  const cartUrl = routes.cart_url || "/cart";
  const addUrl = routes.cart_add_url || "/cart/add.js";
  const changeUrl = routes.cart_change_url || "/cart/change.js";
  const predictUrl = routes.predictive_search_url || "/search/suggest";
  const WISH_KEY = "emesa_wishlist";

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  const formatMoney = (cents) => {
    if (cents == null) return "";
    const format = cfg.moneyFormat || "{{amount}}";
    const value = (Number(cents) / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace(".", ","));
  };

  const toast = (message) => {
    const el = $("[data-toast]");
    if (!el || !message) return;
    el.textContent = message;
    el.classList.add("is-visible");
    window.clearTimeout(toast._t);
    toast._t = window.setTimeout(() => el.classList.remove("is-visible"), 2400);
  };

  const lock = (on) => document.body.classList.toggle("is-locked", on);

  const closeAll = () => {
    $$("[data-drawer]").forEach((el) => {
      el.classList.remove("is-open");
      el.setAttribute("aria-hidden", "true");
      el.removeAttribute("aria-modal");
    });
    $("[data-overlay]")?.classList.remove("is-open");
    lock(false);
  };

  const openDrawer = (name) => {
    const target = $(`[data-drawer="${name}"]`);
    if (!target) return;
    closeAll();
    target.classList.add("is-open");
    target.setAttribute("aria-hidden", "false");
    target.setAttribute("aria-modal", "true");
    $("[data-overlay]")?.classList.add("is-open");
    lock(true);
    const focusable = target.querySelector("input, button, a, textarea, select");
    focusable?.focus();
  };

  const wishRead = () => {
    try {
      return JSON.parse(localStorage.getItem(WISH_KEY) || "[]");
    } catch {
      return [];
    }
  };
  const wishWrite = (list) => localStorage.setItem(WISH_KEY, JSON.stringify(list));
  const wishHas = (handle) => wishRead().includes(handle);
  const wishToggle = (handle) => {
    const list = wishRead();
    const i = list.indexOf(handle);
    if (i >= 0) list.splice(i, 1);
    else list.push(handle);
    wishWrite(list);
    return wishHas(handle);
  };

  const syncWish = () => {
    $$("[data-wish]").forEach((btn) => {
      const on = wishHas(btn.dataset.wish);
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", String(on));
    });
  };

  const updateCartDot = (count) => {
    $$("[data-cart-dot]").forEach((dot) => {
      const n = Number(count || 0);
      dot.hidden = n === 0;
      dot.textContent = n > 9 ? "9+" : String(n);
      dot.classList.toggle("is-on", n > 0);
    });
  };

  const fetchCart = () => fetch(`${cartUrl}.js`, { credentials: "same-origin" }).then((r) => r.json());

  const propertyLines = (item) =>
    Object.entries(item.properties || {})
      .filter(([k, v]) => v && !String(k).startsWith("_"))
      .map(([k, v]) => {
        const isFile = typeof v === "string" && (v.includes("/uploads/") || v.includes("cdn.shopify"));
        return `<p class="cart-note">${k}: ${isFile ? "Uploaded file" : v}</p>`;
      })
      .join("");

  const renderCartDrawer = (cart) => {
    const root = $("[data-cart-drawer]");
    if (!root || !cart) return;
    updateCartDot(cart.item_count);
    if (!cart.items.length) {
      root.innerHTML = `
        <div class="empty-state">
          <svg class="icon icon-lg icon-gold" aria-hidden="true"><use href="#icon-bag"></use></svg>
          <h3>Your bag is empty</h3>
          <p>Your bag is waiting for its first piece of metal art.</p>
          <a class="btn btn-primary" href="${routes.all_products_collection_url || "/collections/all"}" data-close>Explore Metal Art</a>
        </div>`;
      return;
    }
    root.innerHTML = `
      <div class="cart-lines">
        ${cart.items
          .map(
            (item) => `
          <article class="cart-line" data-key="${item.key}" data-line="${item.index || ""}">
            <a class="cart-thumb" href="${item.url}">
              <img src="${item.image || ""}" alt="" width="88" height="110" loading="lazy">
            </a>
            <div class="cart-line-body">
              <h3>${item.product_title}</h3>
              <p>${item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : ""}</p>
              ${propertyLines(item)}
              <div class="cart-line-row">
                <div class="qty" role="group" aria-label="Quantity">
                  <button type="button" data-qty="-1" aria-label="Decrease quantity"><svg class="icon icon-sm" aria-hidden="true"><use href="#icon-minus"></use></svg></button>
                  <span>${item.quantity}</span>
                  <button type="button" data-qty="1" aria-label="Increase quantity"><svg class="icon icon-sm" aria-hidden="true"><use href="#icon-plus"></use></svg></button>
                </div>
                <p class="price">${formatMoney(item.final_line_price)}</p>
                <button class="icon-btn" type="button" data-remove aria-label="Remove ${item.product_title}">
                  <svg class="icon" aria-hidden="true"><use href="#icon-trash"></use></svg>
                </button>
              </div>
            </div>
          </article>`
          )
          .join("")}
      </div>
      <div class="cart-drawer-foot">
        <div class="cart-subtotal"><span>Subtotal</span><strong>${formatMoney(cart.total_price)}</strong></div>
        <p class="muted-note">Shipping calculated at checkout</p>
        <a class="btn btn-primary btn-block" href="${cartUrl}">View Bag</a>
        <form action="${cartUrl}" method="post">
          <button class="btn btn-secondary btn-block" type="submit" name="checkout">Proceed to Checkout</button>
        </form>
        <button class="text-link" type="button" data-close>Continue shopping</button>
      </div>`;
  };

  const refreshCart = () => fetchCart().then(renderCartDrawer).catch(() => {});

  const changeLine = (key, quantity) =>
    fetch(changeUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity }),
    }).then((r) => r.json());

  const addToCart = async (payload) => {
    const isForm = payload instanceof FormData;
    const res = await fetch(addUrl, {
      method: "POST",
      headers: isForm ? { Accept: "application/json" } : { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: isForm ? payload : JSON.stringify(payload),
    });
    const data = await res.json();
    if (!res.ok) throw data;
    return data;
  };

  const parseProductJson = (root) => {
    const node = root.querySelector("[data-product-json]");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch {
      return null;
    }
  };

  const optionValues = (form) =>
    [...form.querySelectorAll("[data-option-input]:checked")].map((el) => el.value);

  const findVariant = (product, values) => {
    if (!product?.variants) return null;
    return product.variants.find((v) => values.every((val, i) => String(v.options[i]) === String(val))) || product.variants[0];
  };

  const updateProductUI = (section, variant) => {
    if (!variant) return;
    const idInput = section.querySelector("[data-variant-id]");
    if (idInput) idInput.value = variant.id;
    section.querySelectorAll("[data-live-price]").forEach((el) => {
      el.textContent = formatMoney(variant.price);
    });
    const priceWrap = section.querySelector("[data-price-wrap]");
    if (priceWrap) {
      priceWrap.innerHTML = `<div class="price${variant.compare_at_price > variant.price ? " price--on-sale" : ""}"><span class="price__regular">${formatMoney(variant.price)}</span>${
        variant.compare_at_price > variant.price ? `<s class="price--compare">${formatMoney(variant.compare_at_price)}</s>` : ""
      }</div>`;
    }
    const add = section.querySelector("[data-add-to-cart]");
    if (add) {
      add.disabled = !variant.available;
      const text = add.querySelector("[data-add-text]");
      if (text) text.textContent = variant.available ? "Add to Cart" : "Sold out";
    }
    if (variant.featured_image) {
      const media = section.querySelector(`[data-media-id="${variant.featured_image.id}"]`);
      if (media) showMedia(section, variant.featured_image.id);
    }
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variant.id);
    history.replaceState({}, "", url);
  };

  const showMedia = (root, id) => {
    root.querySelectorAll("[data-media-id]").forEach((el) => {
      const on = String(el.dataset.mediaId) === String(id);
      el.classList.toggle("is-active", on);
      el.hidden = !on;
    });
    root.querySelectorAll("[data-thumb]").forEach((el) => {
      el.classList.toggle("is-active", String(el.dataset.thumb) === String(id));
    });
    root.querySelectorAll("[data-dot]").forEach((el) => {
      el.classList.toggle("is-active", String(el.dataset.dot) === String(id));
    });
  };

  const bindProduct = (section) => {
    if (!section || section.dataset.bound === "product") return;
    section.dataset.bound = "product";
    const product = parseProductJson(section);
    const form = section.querySelector("form[action*='/cart/add'], .product-form, [data-custom-form]");
    section.addEventListener("change", (event) => {
      if (event.target.matches("[data-option-input]") && product && form) {
        const variant = findVariant(product, optionValues(form));
        updateProductUI(section, variant);
        event.target.closest(".choice")?.parentElement?.querySelectorAll(".choice").forEach((el) => el.classList.remove("is-active"));
        event.target.closest(".choice")?.classList.add("is-active");
      }
    });
    section.addEventListener("click", (event) => {
      const qty = event.target.closest("[data-qty-btn]");
      if (qty && form) {
        const input = form.querySelector('input[name="quantity"]');
        if (input) input.value = Math.max(1, Number(input.value || 1) + Number(qty.dataset.qtyBtn));
      }
      const thumb = event.target.closest("[data-thumb]");
      if (thumb) showMedia(section, thumb.dataset.thumb);
    });
  };

  const bindCustomizer = (root) => {
    if (!root || root.dataset.bound === "custom") return;
    root.dataset.bound = "custom";
    const canOrder = root.dataset.canOrder === "true";
    const form = root.querySelector("form#CustomArtProductForm") || root.querySelector("form[action*='/cart/add']");
    if (form) form.setAttribute("enctype", "multipart/form-data");
    const file = root.querySelector("[data-file]");
    const img = root.querySelector("[data-preview-image]");
    const empty = root.querySelector("[data-preview-empty]");
    const idle = root.querySelector("[data-upload-idle]");
    const done = root.querySelector("[data-upload-done]");
    const error = root.querySelector("[data-upload-error]");
    const note = root.querySelector("[data-note]");
    const stage = root.querySelector("[data-preview-stage]");
    const idInput = root.querySelector("[data-variant-id]");
    const fitInput = root.querySelector("[data-fit-input]");
    const zoomInput = root.querySelector("[data-zoom-input]");
    const positionInput = root.querySelector("[data-position-input]");
    const displayInput = root.querySelector("[data-display-input]");
    const giftInput = root.querySelector("[data-gift-input]");
    const addBtn = root.querySelector("[data-add-to-cart]");
    let objectUrl = "";
    const getSizeMetrics = (label) => {
      const values = String(label || "").match(/\d+(?:\.\d+)?/g) || [];
      const width = Number(values[0]) || 30;
      const height = Number(values[1]) || 45;
      const sizes = [...root.querySelectorAll("[data-size]")]
        .map((button) => String(button.dataset.size || "").match(/\d+(?:\.\d+)?/g) || [])
        .map((dimensions) => Math.max(Number(dimensions[0]) || 0, Number(dimensions[1]) || 0));
      const largestSide = Math.max(...sizes, Math.max(width, height), 1);

      return {
        scale: Math.max(width, height) / largestSide,
        ratio: `${width} / ${height}`,
      };
    };
    const state = {
      fit: "fill",
      zoom: 100,
      posX: 50,
      posY: 50,
      artX: 0,
      artY: 0,
      artScale: 2 / 3,
      artRatio: "2 / 3",
      display: "Wall Mount",
      gift: false,
      step: "photo",
    };

    const setText = (sel, value) => {
      root.querySelectorAll(sel).forEach((el) => {
        el.textContent = value;
      });
    };
    const showError = (msg) => {
      if (!error) return;
      error.hidden = !msg;
      error.textContent = msg || "";
    };
    const isDesktop = () => window.matchMedia("(min-width: 1025px)").matches;
    const hasImage = () => Boolean(objectUrl);

    const paintPreview = () => {
      const has = hasImage();
      if (stage) {
        stage.classList.toggle("has-image", has);
        stage.dataset.display = state.display === "Table Stand" ? "table" : "wall";
        stage.dataset.fit = state.fit;
        stage.tabIndex = has ? -1 : 0;
        stage.setAttribute("role", has ? "img" : "button");
        stage.setAttribute("aria-label", has ? "Artwork preview" : "Upload a photo to preview your metal art");
        stage.style.setProperty("--art-x", `${state.artX}px`);
        stage.style.setProperty("--art-y", `${state.artY}px`);
        stage.style.setProperty("--art-scale", String(state.artScale));
        stage.style.setProperty("--art-ratio", state.artRatio);
      }
      if (img) {
        img.hidden = !has;
        if (has) img.src = objectUrl;
        img.style.objectFit = state.fit === "fit" ? "contain" : state.fit === "center" ? "none" : "cover";
        img.style.objectPosition = `${state.posX}% ${state.posY}%`;
        img.style.transform = `scale(${state.zoom / 100})`;
      }
      if (zoomInput) zoomInput.value = `${state.zoom}%`;
      if (positionInput) positionInput.value = `${Math.round(state.posX)}% horizontal, ${Math.round(state.posY)}% vertical`;
      if (empty) empty.hidden = has;
      if (idle) idle.hidden = has;
      if (done) done.hidden = !has;
      const thumb = root.querySelector("[data-thumb]");
      if (thumb && has) thumb.src = objectUrl;
      setText("[data-photo-meta]", has ? "Uploaded" : "Not added");
      setText("[data-sum-photo]", has ? "Uploaded" : "Not added");
      setText("[data-sum-display]", state.display);
      setText("[data-sum-gift]", state.gift ? "Gift Packaging" : "Standard");
      setText("[data-sum-note-state]", note?.value ? "Included" : "None");
      root.querySelectorAll("[data-fit]").forEach((el) => {
        const on = el.dataset.fit === state.fit;
        el.classList.toggle("is-active", on);
        el.setAttribute("aria-checked", String(on));
      });
      root.querySelectorAll("[data-display]").forEach((el) => {
        const on = el.dataset.display === state.display;
        el.classList.toggle("is-active", on);
        el.setAttribute("aria-checked", String(on));
      });
      const giftBtn = root.querySelector("[data-gift]");
      if (giftBtn) {
        giftBtn.classList.toggle("is-active", state.gift);
        giftBtn.setAttribute("aria-pressed", String(state.gift));
      }
      const zoom = root.querySelector("[data-zoom]");
      if (zoom) zoom.value = String(state.zoom);
      paintRoom();
    };

    const paintRoom = () => {
      const room = document.querySelector("[data-room-stage]");
      if (!room) return;
      const art = document.querySelector("[data-room-art]");
      const emptyRoom = document.querySelector("[data-room-empty]");
      room.style.setProperty("--room-art-scale", String(state.artScale));
      room.style.setProperty("--room-art-ratio", state.artRatio);
      if (art) {
        art.hidden = !objectUrl;
        if (objectUrl) {
          art.src = objectUrl;
          art.style.objectFit = state.fit === "fit" ? "contain" : "cover";
          art.style.objectPosition = `${state.posX}% ${state.posY}%`;
        }
      }
      if (emptyRoom) emptyRoom.hidden = Boolean(objectUrl);
    };

    const selectSize = (btn) => {
      if (!btn) return;
      root.querySelectorAll("[data-size]").forEach((el) => {
        const on = el === btn;
        el.classList.toggle("is-active", on);
        el.setAttribute("aria-checked", String(on));
      });
      if (idInput && btn.dataset.variantId) idInput.value = btn.dataset.variantId;
      const metrics = getSizeMetrics(btn.dataset.size);
      state.artScale = metrics.scale;
      state.artRatio = metrics.ratio;
      setText("[data-sum-size]", btn.dataset.size);
      const cents = Number(btn.dataset.price);
      root.querySelectorAll("[data-live-price]").forEach((el) => {
        el.textContent = formatMoney(cents);
      });
      document.querySelectorAll(".create-sticky [data-live-price], .create-sticky [data-sum-size]").forEach((el) => {
        if (el.matches("[data-live-price]")) el.textContent = formatMoney(cents);
        if (el.matches("[data-sum-size]")) el.textContent = btn.dataset.size;
      });
      if (addBtn) addBtn.disabled = !canOrder || btn.dataset.available === "false";
      document.querySelectorAll(".create-sticky [name='add']").forEach((el) => {
        el.disabled = !canOrder || btn.dataset.available === "false";
      });
      root.querySelectorAll("[data-guide-size]").forEach((el) => {
        el.classList.toggle("is-active", el.dataset.guideSize === btn.dataset.size);
      });
      paintPreview();
      if (canOrder && btn.dataset.variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", btn.dataset.variantId);
        history.replaceState({}, "", url);
      }
    };

    const openStep = (name) => {
      state.step = name;
      root.querySelectorAll("[data-step]").forEach((el) => {
        el.classList.toggle("is-open", isDesktop() ? true : el.dataset.step === name);
      });
      root.querySelectorAll("[data-goto]").forEach((btn) => {
        btn.classList.toggle("is-active", btn.dataset.goto === name);
        btn.toggleAttribute("aria-current", btn.dataset.goto === name);
      });
      root.querySelectorAll("[data-toggle-step]").forEach((btn) => {
        btn.setAttribute("aria-expanded", String(btn.dataset.toggleStep === name || isDesktop()));
      });
    };

    const onFile = (f) => {
      if (!f) return;
      const okType = ["image/jpeg", "image/png", "image/webp"].includes(f.type) || /\.(jpe?g|png|webp)$/i.test(f.name);
      if (!okType) {
        showError("Please upload a JPG, PNG or WEBP image.");
        if (file) file.value = "";
        return;
      }
      if (f.size > 8 * 1024 * 1024) {
        showError("That file is too large. Please choose an image under 8 MB.");
        if (file) file.value = "";
        return;
      }
      showError("");
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = URL.createObjectURL(f);
      state.posX = 50;
      state.posY = 50;
      const name = root.querySelector("[data-file-name]");
      if (name) name.textContent = f.name;
      paintPreview();
    };

    const pick = () => file?.click();

    const lastFocus = { el: null };
    const closeModal = (name) => {
      const modal = document.querySelector(`[data-modal="${name}"]`);
      if (!modal) return;
      modal.hidden = true;
      document.body.classList.remove("is-locked");
      lastFocus.el?.focus();
    };
    const openModal = (name) => {
      const modal = document.querySelector(`[data-modal="${name}"]`);
      if (!modal) return;
      lastFocus.el = document.activeElement;
      modal.hidden = false;
      document.body.classList.add("is-locked");
      paintRoom();
      modal.querySelector(".emesa-modal-sheet")?.focus();
    };

    document.querySelectorAll(".emesa-modal").forEach((modal) => {
      modal.hidden = true;
    });
    if (giftInput) giftInput.disabled = true;
    const initialSize = root.querySelector("[data-size].is-active");
    if (initialSize) {
      const metrics = getSizeMetrics(initialSize.dataset.size);
      state.artScale = metrics.scale;
      state.artRatio = metrics.ratio;
    }

    if (isDesktop()) root.querySelectorAll("[data-step]").forEach((el) => el.classList.add("is-open"));
    else openStep("photo");
    paintPreview();

    stage?.addEventListener("click", (event) => {
      if (hasImage()) return;
      if (event.target.closest("button")) return;
      pick();
    });
    stage?.addEventListener("keydown", (event) => {
      if (hasImage()) return;
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        pick();
      }
    });
    stage?.addEventListener("dragover", (event) => {
      event.preventDefault();
      stage.classList.add("is-over");
    });
    stage?.addEventListener("dragleave", () => stage.classList.remove("is-over"));
    stage?.addEventListener("drop", (event) => {
      event.preventDefault();
      stage.classList.remove("is-over");
      const dropped = event.dataTransfer.files?.[0];
      if (dropped && file) {
        const transfer = new DataTransfer();
        transfer.items.add(dropped);
        file.files = transfer.files;
      }
      onFile(dropped);
    });
    file?.addEventListener("change", () => onFile(file.files?.[0]));

    root.addEventListener("click", (event) => {
      if (event.target.closest("[data-replace-image], [data-upload-idle]")) {
        event.preventDefault();
        pick();
      }
      if (event.target.closest("[data-remove-image]")) {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        objectUrl = "";
        if (file) file.value = "";
        paintPreview();
      }
      const size = event.target.closest("[data-size]");
      if (size) selectSize(size);
      const fit = event.target.closest("[data-fit]");
      if (fit) {
        state.fit = fit.dataset.fit;
        if (fitInput) fitInput.value = state.fit;
        if (state.fit !== "fill") {
          state.posX = 50;
          state.posY = 50;
        }
        paintPreview();
      }
      const move = event.target.closest("[data-position-move]");
      if (move) {
        const amount = 8;
        if (move.dataset.positionMove === "up") state.posY = Math.max(0, state.posY - amount);
        if (move.dataset.positionMove === "down") state.posY = Math.min(100, state.posY + amount);
        if (move.dataset.positionMove === "left") state.posX = Math.max(0, state.posX - amount);
        if (move.dataset.positionMove === "right") state.posX = Math.min(100, state.posX + amount);
        if (move.dataset.positionMove === "reset") { state.posX = 50; state.posY = 50; state.zoom = 100; }
        paintPreview();
      }
      const artworkMove = event.target.closest("[data-artwork-move]");
      if (artworkMove) {
        const amount = 14;
        if (artworkMove.dataset.artworkMove === "up") state.artY -= amount;
        if (artworkMove.dataset.artworkMove === "down") state.artY += amount;
        if (artworkMove.dataset.artworkMove === "left") state.artX -= amount;
        if (artworkMove.dataset.artworkMove === "right") state.artX += amount;
        if (artworkMove.dataset.artworkMove === "reset") { state.artX = 0; state.artY = 0; }
        state.artX = Math.max(-130, Math.min(130, state.artX));
        state.artY = Math.max(-105, Math.min(105, state.artY));
        paintPreview();
      }
      const display = event.target.closest("[data-display]");
      if (display) {
        state.display = display.dataset.display;
        if (displayInput) displayInput.value = state.display;
        paintPreview();
      }
      const gift = event.target.closest("[data-gift]");
      if (gift) {
        state.gift = !state.gift;
        if (giftInput) {
          giftInput.disabled = !state.gift;
          giftInput.value = state.gift ? "Gift Packaging" : "";
        }
        paintPreview();
      }
      const goto = event.target.closest("[data-goto]");
      if (goto) openStep(goto.dataset.goto);
      const toggle = event.target.closest("[data-toggle-step]");
      if (toggle && !isDesktop()) openStep(toggle.dataset.toggleStep);
      const opener = event.target.closest("[data-open-modal]");
      if (opener) {
        event.preventDefault();
        openModal(opener.dataset.openModal);
      }
    });

    if (!document.body.dataset.emesaCreateModals) {
      document.body.dataset.emesaCreateModals = "true";
      document.addEventListener("click", (event) => {
        const closer = event.target.closest("[data-close-modal]");
        if (closer) {
          closeModal(closer.closest("[data-modal]")?.dataset.modal);
          return;
        }
        const scene = event.target.closest(".room-scenes [data-scene]");
        if (scene) {
          const room = document.querySelector("[data-room-stage]");
          const bg = document.querySelector("[data-room-bg]");
          if (room) room.dataset.scene = scene.dataset.scene;
          if (bg && scene.dataset.sceneSrc) bg.src = scene.dataset.sceneSrc;
          document.querySelectorAll(".room-scenes [data-scene]").forEach((btn) => {
            const on = btn === scene;
            btn.classList.toggle("is-active", on);
            btn.setAttribute("aria-selected", String(on));
          });
          const art = document.querySelector("[data-room-art]");
          const emptyRoom = document.querySelector("[data-room-empty]");
          const preview = document.querySelector("[data-preview-image]");
          if (art && preview && !preview.hidden) {
            art.hidden = false;
            art.src = preview.src;
          }
          if (emptyRoom) emptyRoom.hidden = Boolean(art && !art.hidden);
        }
        const guide = event.target.closest("[data-guide-size]");
        if (guide) {
          const studio = document.querySelector("[data-customizer]");
          const match = [...(studio?.querySelectorAll("[data-size]") || [])].find((el) =>
            (guide.dataset.variantId && el.dataset.variantId === guide.dataset.variantId) ||
            el.dataset.size === guide.dataset.guideSize
          );
          match?.click();
        }
      });
      document.addEventListener("keydown", (event) => {
        const open = document.querySelector(".emesa-modal:not([hidden])");
        if (!open) return;
        if (event.key === "Escape") {
          event.preventDefault();
          closeModal(open.dataset.modal);
        }
      });
    }

    note?.addEventListener("input", () => {
      const count = root.querySelector("[data-note-count]");
      if (count) count.textContent = `${note.value.length} / 150`;
      setText("[data-sum-note-state]", note.value ? "Included" : "None");
    });
    root.querySelector("[data-zoom]")?.addEventListener("input", (event) => {
      state.zoom = Number(event.target.value);
      paintPreview();
    });

    if (img && stage) {
      let dragging = false;
      let origin = { x: 0, y: 0, px: 50, py: 50 };
      img.addEventListener("pointerdown", (event) => {
        if (state.fit !== "fill" || !objectUrl) return;
        dragging = true;
        stage.classList.add("is-dragging");
        origin = { x: event.clientX, y: event.clientY, px: state.posX, py: state.posY };
        img.setPointerCapture(event.pointerId);
      });
      img.addEventListener("pointermove", (event) => {
        if (!dragging) return;
        const rect = img.getBoundingClientRect();
        const dx = ((event.clientX - origin.x) / rect.width) * 100;
        const dy = ((event.clientY - origin.y) / rect.height) * 100;
        state.posX = Math.min(100, Math.max(0, origin.px - dx));
        state.posY = Math.min(100, Math.max(0, origin.py - dy));
        img.style.objectPosition = `${state.posX}% ${state.posY}%`;
      });
      img.addEventListener("pointerup", () => {
        dragging = false;
        stage.classList.remove("is-dragging");
      });
    }

    const cta = root.querySelector("[data-main-cta]");
    const bar = root.querySelector("[data-sticky-cta]") || document.querySelector("[data-sticky-cta]");
    if (cta && bar) {
      const apply = (visibleMain) => {
        if (window.matchMedia("(max-width: 1024px)").matches) {
          bar.classList.add("is-visible");
          return;
        }
        bar.classList.toggle("is-visible", !visibleMain);
      };
      apply(true);
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(([entry]) => apply(entry.isIntersecting), { threshold: 0.4 }).observe(cta);
      }
    }

    window.addEventListener("resize", () => {
      if (isDesktop()) root.querySelectorAll("[data-step]").forEach((el) => el.classList.add("is-open"));
    }, { passive: true });

    form?.addEventListener("submit", () => {
      if (fitInput) fitInput.value = state.fit;
      if (zoomInput) zoomInput.value = `${state.zoom}%`;
      if (positionInput) positionInput.value = `${Math.round(state.posX)}% horizontal, ${Math.round(state.posY)}% vertical`;
      if (displayInput) displayInput.value = state.display;
      if (giftInput) {
        giftInput.disabled = !state.gift;
        giftInput.value = state.gift ? "Gift Packaging" : "";
      }
    });
  };


  const bindGallery = (root) => {
    const gallery = root?.querySelector?.("[data-product-gallery]") || (root?.matches?.("[data-product-gallery]") ? root : null);
    if (!gallery || gallery.dataset.bound === "gallery") return;
    gallery.dataset.bound = "gallery";
    const medias = [...gallery.querySelectorAll("[data-media-id]")];
    if (medias.length < 2) return;
    let startX = 0;
    gallery.addEventListener("touchstart", (e) => { startX = e.changedTouches[0].clientX; }, { passive: true });
    gallery.addEventListener("touchend", (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < 40) return;
      const current = medias.findIndex((m) => !m.hidden);
      const next = dx < 0 ? Math.min(medias.length - 1, current + 1) : Math.max(0, current - 1);
      showMedia(gallery, medias[next].dataset.mediaId);
    }, { passive: true });
    gallery.querySelector(".pdp-main")?.addEventListener("click", (e) => {
      const img = e.target.closest("img");
      if (!img) return;
      img.classList.toggle("is-zoomed");
    });
  };

  const bindCompare = (slider) => {
    if (!slider || slider.dataset.bound) return;
    slider.dataset.bound = "1";
    const handle = slider.querySelector("[data-reveal-handle]");
    const after = slider.querySelector(".reveal-after");
    if (!handle || !after) return;
    const set = (pct) => {
      const v = Math.min(100, Math.max(0, pct));
      after.style.clipPath = `inset(0 0 0 ${v}%)`;
      handle.style.left = `${v}%`;
      handle.setAttribute("aria-valuenow", String(Math.round(v)));
    };
    set(50);
    const move = (clientX) => {
      const rect = slider.getBoundingClientRect();
      set(((clientX - rect.left) / rect.width) * 100);
    };
    handle.addEventListener("pointerdown", (e) => {
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener("pointermove", (e) => {
      if (handle.hasPointerCapture(e.pointerId)) move(e.clientX);
    });
    slider.addEventListener("click", (e) => {
      if (e.target === handle) return;
      move(e.clientX);
    });
    handle.addEventListener("keydown", (e) => {
      const now = Number(handle.getAttribute("aria-valuenow") || 50);
      if (e.key === "ArrowLeft") set(now - 4);
      if (e.key === "ArrowRight") set(now + 4);
    });
  };

  const reveals = () => {
    const nodes = $$(".reveal, .reveal-image");
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !("IntersectionObserver" in window)) {
      nodes.forEach((el) => el.classList.add("is-in"));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    nodes.forEach((el) => observer.observe(el));
  };

  const predictive = (() => {
    let timer = 0;
    const run = async (q, box) => {
      if (!box) return;
      if (!q || q.length < 2) {
        box.innerHTML = "";
        return;
      }
      try {
        const url = `${predictUrl}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive`;
        const res = await fetch(`${predictUrl}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`, {
          headers: { Accept: "application/json" },
        });
        const data = await res.json();
        const products = data.resources?.results?.products || [];
        if (!products.length) {
          box.innerHTML = `<p>No quick matches.</p>`;
          return;
        }
        box.innerHTML = products
          .map((p) => {
            const img = typeof p.featured_image === "string" ? p.featured_image : p.featured_image?.url;
            const raw = p.price;
            const cents = typeof raw === "number" ? raw : Math.round(parseFloat(raw) * 100);
            const price = Number.isFinite(cents) ? formatMoney(cents) : "";
            const type = p.product_type || p.type || "";
            return `<a href="${p.url}">${img ? `<img src="${img}" alt="" width="48" height="60">` : ""}<span>${p.title}${price ? `<small>${price}${type ? ` · ${type}` : ""}</small>` : ""}</span></a>`;
          })
          .join("");
      } catch {
        box.innerHTML = "";
      }
    };
    return (input) => {
      const box = input.closest("[data-drawer], form, .search-panel")?.querySelector("[data-search-suggest]") || $("[data-search-suggest]");
      window.clearTimeout(timer);
      timer = window.setTimeout(() => run(input.value.trim(), box), 220);
    };
  })();

  const renderWishlistPage = async () => {
    const grid = $("[data-wishlist-grid]");
    const empty = $("[data-wishlist-empty]");
    const saved = $("[data-wishlist-saved]");
    const count = $("[data-wishlist-count]");
    if (!grid) return;
    const handles = wishRead();
    if (count) count.textContent = String(handles.length);
    if (!handles.length) {
      grid.innerHTML = "";
      if (empty) empty.hidden = false;
      if (saved) saved.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (saved) saved.hidden = false;
    const cards = await Promise.all(
      handles.map(async (handle) => {
        try {
          const res = await fetch(`/products/${handle}.js`);
          if (!res.ok) return "";
          const p = await res.json();
          const img = p.featured_image || (p.images && p.images[0]) || "";
          return `<article class="product-card wishlist-card reveal is-in">
            <div class="product-media"><a href="${p.url}"><img src="${img}" alt="${p.title}" width="800" height="1000" loading="lazy"></a>
              <button class="wishlist is-active" type="button" data-wish="${p.handle}" aria-pressed="true" aria-label="Remove ${p.title}"><svg class="icon icon-heart" aria-hidden="true"><use href="#icon-heart"></use></svg></button>
            </div>
            <h3><a href="${p.url}">${p.title}</a></h3>
            <div class="product-meta"><p class="price">${formatMoney(p.price)}</p></div>
          </article>`;
        } catch {
          return "";
        }
      })
    );
    grid.innerHTML = cards.join("");
    syncWish();
  };

  const loadRecommendations = () => {
    $$("product-recommendations[data-url]").forEach(async (el) => {
      try {
        const res = await fetch(el.dataset.url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const next = doc.querySelector(".shopify-section") || doc.body;
        if (next && next.querySelector(".product-card")) el.replaceWith(next);
      } catch {}
    });
  };

  const onSubmit = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.matches("[data-product-form], .product-form, [data-custom-form], form[action*='/cart/add']")) {
      if (!cfg.cartDrawer) return;
      event.preventDefault();
      const err = form.querySelector("[data-product-error]");
      if (err) err.hidden = true;
      if (form.dataset.previewOnly === "true") {
        event.preventDefault();
        return;
      }
      const file = form.querySelector('input[type="file"]');
      if (file && file.required && !file.files?.length) {
        toast(cfg.strings?.needPhoto || "Please upload a photo before adding to bag.");
        return;
      }
      try {
        await addToCart(new FormData(form));
        toast(cfg.strings?.added || "Added to bag");
        await refreshCart();
        openDrawer("cart");
      } catch (e) {
        const msg = e?.description || e?.message || cfg.strings?.addError || "Could not update bag.";
        if (err) {
          err.hidden = false;
          err.textContent = msg;
        } else toast(msg);
      }
    }
  };

  const bindGlobal = () => {
    if (document.body.dataset.emesaBound) return;
    document.body.dataset.emesaBound = "true";

    const header = $(".site-header");
    const onScroll = () => header?.classList.toggle("is-scrolled", window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    document.addEventListener("click", async (event) => {
      const opener = event.target.closest("[data-open]");
      if (opener) {
        event.preventDefault();
        if (opener.dataset.open === "cart") await refreshCart();
        openDrawer(opener.dataset.open);
        return;
      }
      if (event.target.closest("[data-overlay], button[data-close], .text-link[data-close]")) {
        event.preventDefault();
        closeAll();
        return;
      }
      if (event.target.closest("a[data-close]")) closeAll();

      const acc = event.target.closest("[data-acc]");
      if (acc) {
        const parent = acc.parentElement;
        const open = !parent?.classList.contains("is-open");
        parent?.classList.toggle("is-open", open);
        acc.setAttribute("aria-expanded", String(open));
      }

      const wishBtn = event.target.closest("[data-wish]");
      if (wishBtn) {
        event.preventDefault();
        const on = wishToggle(wishBtn.dataset.wish);
        toast(on ? cfg.strings?.wishOn : cfg.strings?.wishOff);
        syncWish();
        renderWishlistPage();
      }

      const quick = event.target.closest("[data-quick-add]");
      if (quick) {
        event.preventDefault();
        if (quick.dataset.needsOptions === "true") {
          window.location.href = quick.closest("article")?.querySelector("a")?.href || window.location.href;
          return;
        }
        try {
          await addToCart({ items: [{ id: Number(quick.dataset.variantId), quantity: 1 }] });
          toast(cfg.strings?.added || "Added to bag");
          await refreshCart();
          openDrawer("cart");
        } catch {
          toast(cfg.strings?.addError);
        }
      }

      const line = event.target.closest(".cart-line");
      if (line?.dataset.key) {
        const key = line.dataset.key;
        const qtyEl = line.querySelector(".qty span");
        const current = Number(qtyEl?.textContent || 1);
        if (event.target.closest("[data-remove]")) {
          await changeLine(key, 0);
          await refreshCart();
          toast("Removed from bag");
        }
        const qtyBtn = event.target.closest("[data-qty]");
        if (qtyBtn) {
          await changeLine(key, Math.max(0, current + Number(qtyBtn.dataset.qty)));
          await refreshCart();
        }
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeAll();
    });
    document.addEventListener("click", (event) => {
      const button = event.target.closest("[data-cart-quantity]");
      if (!button) return;
      const control = button.closest(".qty-page");
      const input = control?.querySelector('input[type="number"]');
      if (!input) return;
      const next = Math.max(0, Number(input.value || 0) + Number(button.dataset.cartQuantity || 0));
      input.value = next;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    document.addEventListener("click", (event) => {
      const button = event.target.closest("[data-business-quantity]");
      if (!button) return;
      const control = button.closest(".business-quantity");
      const input = control?.querySelector('input[type="number"]');
      if (!input) return;
      input.value = Math.max(1, Number(input.value || 1) + Number(button.dataset.businessQuantity || 0));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    document.addEventListener("submit", onSubmit);
    document.addEventListener("input", (e) => {
      if (e.target.matches("[data-live-search]")) predictive(e.target);
    });
  };

  const bindHeroSlider = (slider) => {
    if (!slider || slider.dataset.bound === "hero-slider") return;
    slider.dataset.bound = "hero-slider";
    const slides = $$('[data-hero-slide]', slider);
    if (slides.length < 2) return;
    const dots = $$('[data-hero-dot]', slider);
    let active = 0;
    let timer;
    const show = (next) => {
      active = (next + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const on = index === active;
        slide.classList.toggle("is-active", on);
        slide.setAttribute("aria-hidden", String(!on));
        slide.querySelectorAll("video").forEach((video) => on ? video.play().catch(() => {}) : video.pause());
      });
      dots.forEach((dot, index) => {
        const on = index === active;
        dot.classList.toggle("is-active", on);
        dot.setAttribute("aria-current", String(on));
      });
    };
    const restart = () => {
      window.clearInterval(timer);
      if (slider.dataset.autoplay === "true" && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) timer = window.setInterval(() => show(active + 1), Number(slider.dataset.interval || 6000));
    };
    slider.querySelector("[data-hero-prev]")?.addEventListener("click", () => { show(active - 1); restart(); });
    slider.querySelector("[data-hero-next]")?.addEventListener("click", () => { show(active + 1); restart(); });
    dots.forEach((dot, index) => dot.addEventListener("click", () => { show(index); restart(); }));
    restart();
  };

  const init = () => {
    closeAll();
    bindGlobal();
    $$("[data-product-section], [data-customizer]").forEach(bindProduct);
    $$("[data-customizer]").forEach(bindCustomizer);
    $$("[data-reveal-slider]").forEach(bindCompare);
    $$("[data-hero-slider]").forEach(bindHeroSlider);
    $$("[data-product-gallery]").forEach(bindGallery);
    syncWish();
    reveals();
    refreshCart();
    renderWishlistPage();
    loadRecommendations();
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();

  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target;
    bindProduct(root.querySelector("[data-product-section]") || root);
    bindCustomizer(root.querySelector("[data-customizer]") || (root.matches("[data-customizer]") ? root : null));
    $$("[data-reveal-slider]", root).forEach(bindCompare);
    bindGallery(root);
    $$("[data-hero-slider]", root).forEach(bindHeroSlider);
    reveals();
    syncWish();
  });
  document.addEventListener("shopify:section:unload", () => {});
})();
